import { render, staticRenderFns } from "./s-toggle.vue?vue&type=template&id=3af2bc94&"
import script from "./s-toggle.vue?vue&type=script&lang=js&"
export * from "./s-toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af2bc94')) {
      api.createRecord('3af2bc94', component.options)
    } else {
      api.reload('3af2bc94', component.options)
    }
    module.hot.accept("./s-toggle.vue?vue&type=template&id=3af2bc94&", function () {
      api.rerender('3af2bc94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/default/src/components/ui-components/s-toggle/s-toggle.vue"
export default component.exports